/* eslint-disable react/display-name */
import React from 'react';
import { ArrowCDownIcon16Regular } from "../../icons2022/ArrowCDownIcon/ArrowCDownIcon16Regular";
import { ArrowCDownIcon20Regular } from "../../icons2022/ArrowCDownIcon/ArrowCDownIcon20Regular";
import { ArrowCDownIcon24Regular } from "../../icons2022/ArrowCDownIcon/ArrowCDownIcon24Regular";
import { iconSizer } from "../../icons2022/iconSizer";
export var ArrowDownIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(ArrowCDownIcon16Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(ArrowCDownIcon20Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(ArrowCDownIcon24Regular, null);
  }
}, 'ArrowDownIcon');